import Chip from '@components/v2/ui/Chip/Chip';
import Icon from '@components/v2/ui/Icon/Icon';
import { FormHelperText, Grid } from '@mui/material';
import { Check, Plus } from 'lucide-react';
import { SegmentOption } from '../segment.type';

type SegmentsPickerProps = {
  options: SegmentOption[];
  selectedIds: string[];
  helperText?: string;
  hasError?: boolean;
  testId?: string;
  onToggle: (segmentId: string) => void;
};

const SegmentsPicker = ({
  options,
  selectedIds,
  helperText,
  hasError,
  testId,
  onToggle,
}: SegmentsPickerProps) => (
  <>
    {helperText && <FormHelperText error={hasError}>{helperText}</FormHelperText>}
    <Grid container spacing={1}>
      {options.map((option) => {
        const isSelected = selectedIds.includes(option.value);

        return (
          <Grid key={option.value} size="auto">
            <Chip
              label={option.label}
              color={isSelected ? 'secondary' : 'default'}
              disabled={option.disabled}
              testId={testId && `${testId}_${option.value}`}
              icon={<Icon icon={isSelected ? Check : Plus} size="sm" />}
              slotProps={{ root: { 'aria-pressed': isSelected } }}
              onClick={() => onToggle(option.value)}
            />
          </Grid>
        );
      })}
    </Grid>
  </>
);

export default SegmentsPicker;
